// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const giratina_origin: PokeData = {
  "id": 10007,
  "name": "giratina-origin",
  "height": 69,
  "weight": 6500,
  "base_experience": 340,
  "types": [
    PokeType.GHOST,
    PokeType.DRAGON
  ],
  "api_moves": [
    "slash",
    "scary-face",
    "destiny-bond",
    "pain-split",
    "dragon-breath",
    "ancient-power",
    "shadow-ball",
    "dragon-claw",
    "heal-block",
    "aura-sphere",
    "dragon-pulse",
    "earth-power",
    "shadow-claw",
    "shadow-sneak",
    "defog",
    "ominous-wind",
    "shadow-force",
    "hex"
  ],
  "moves": [
    "scary-face",
    "dragon-breath",
    "ancient-power",
    "shadow-ball",
    "dragon-claw",
    "dragon-pulse",
    "earth-power",
    "shadow-sneak",
    "dragon-rush",
    "dragon-dance",
    "poltergeist",
    "scale-shot",
    "dragon-vortex"
  ],
  "evolution_chain": {
    "id": 248,
    "item": null,
    "species": [
      {
        "name": "giratina",
        "order": 488,
        "types": [
          PokeType.GHOST,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 149,
    "speed": 107,
    "ability_power": 143
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
